import React, { FC } from 'react';
import useMiniCard from 'hooks/useMiniCard';
import { DateStyles } from './DateStyles';

interface Props {
  className?: string;
}

const Date: FC<Props> = ({ className }) => {
  const {
    data: {
      advert: { formattedDate },
    },
  } = useMiniCard();

  return <DateStyles className={className}>{`доб. ${formattedDate}`}</DateStyles>;
};

export default Date;
